<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
    <!-- <transition name="fade" mode="out-in" v-if="$route.meta.keepAlive">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>

    <transition name="fade" mode="out-in" v-if="!$route.meta.keepAlive">
      <router-view></router-view>
    </transition> -->
    <!-- <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    key () {
      return this.$route.fullPath
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  font-family: Microsoft YaHei, Helvetica Neue, Helvetica, PingFang SC,
    Hiragino Sans GB, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
a {
  color: #56a9ff;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue